import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import Select from '@/components/ui/fields/Select';
import { ElectricityAlarmsHistoryContext } from '@/pages/electricity-alarms-history-page/ElectricityAlarmsHistoryPage';

import FilterItemWrapper from '../fields/FilterItemWrapper';

export type ElectricityAlarmHistoryFilter = {
  odometerId?: string;
  sortBy?: 'id' | 'odometer' | undefined;
  descending?: boolean;
};

export type AlarmsHistoryFiltersProps = {
  filter: ElectricityAlarmHistoryFilter;
  updateFilter: (key: string, value: string) => void;
};

const ElectricityAlarmsHistoryFilters: FC<AlarmsHistoryFiltersProps> = ({
  updateFilter,
  filter,
}) => {
  const { t } = useTranslation();
  const odometers = useContext(ElectricityAlarmsHistoryContext);

  const filters = () => {
    return [
      <Select
        key="odometerName"
        name="odometerName"
        options={odometers || []}
        onChange={(value) => updateFilter('odometerId', value as string)}
        onBlur={() => {}}
        error=""
        required={false}
        label={t('electricityPage.alarmPage.odometer')}
        value={filter.odometerId || ''}
        clearable
      />,
    ];
  };

  return (
    <>
      {filters().map((filter) => (
        <FilterItemWrapper key={filter.key}>{filter}</FilterItemWrapper>
      ))}
    </>
  );
};

export default ElectricityAlarmsHistoryFilters;
